import React, {useState, useEffect} from 'react';
import './BoxPlayOff.css';
import { domain, getLongNameChamp } from '../variables';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from '../i18n';

import {
    IoIosArrowUp
} from "react-icons/io";

function BoxPlayOff({championnat}) {
    const { t, locale } = useTranslation();
    const navigate = useNavigate();
    const [currentOnglet, setCurrentOnglet] = useState(1);
    const [matchsPO, setMatchsPO] = useState(null);
    const [matchsPD, setMatchsPD] = useState(null);
    const [parsedMatchPO, setParsedMatchPO] = useState([]);
    const [parsedMatchPD, setParsedMatchPD] = useState([]);
    const [currentDayPO, setCurrentDayPO] = useState(null);
    const [currentDayPD, setCurrentDayPD] = useState(null);
   

    useEffect(() =>  {
        getPlayOff()
        getPlayDown();
    }, [])

    // Fonction pour récupérer les matchs de playoffs
    const getPlayoffsMatchs = async (currentDayPO = 1) => {
        // on construit l'URL
        const url = `${domain}/server/getPODMatchs.php`;
        try {
            const response = await axios.post(url, {
                division: championnat,
                offOrDown: "off",
                withSets: false
            })

            if (response) {
                setMatchsPO(response.data);
                parseMatchPO(response.data, currentDayPO);
                calculateCurrentDay(response.data, true);
            }
        } 
        catch (error) {
            console.log(error);
        }
    }
    // Fonction pour récupérer les matchs de playoffs
    const getPlaydownMatchs = async (currentDayPD = 1) => {
        // on construit l'URL
        const url = `${domain}/server/getPODMatchs.php`;
        try {
            const response = await axios.post(url, {
                division: championnat,
                offOrDown: "down",
                withSets: false
            })

            if (response) {
                setMatchsPD(response.data);
                parseMatchPD(response.data, currentDayPD);
                calculateCurrentDay(response.data, false);
            }
        } 
        catch (error) {
            console.log(error);
        }
    }

    const calculateCurrentDay = (matchs, isPlayOff) => {
        const today = new Date();
        const matchParsed = [];
        const currentHighestDay = getCurrentHighestDay(matchs);

        // Pour chaque match
        matchs.forEach((match) => {
            // on récupère la date du match
            let date = match.date;
            date = new Date(date.split('/')[2] + '-' + date.split('/')[1] + '-' + date.split('/')[0]);
            // on récupère la journée
            const day = parseInt(match.day_id);
            // si la date est < today alors on ne la compte pas dans le calcul
            if (date < today + 1) return;
            // si la journée du match est déjà passé alors on ne la compte pas dans le calcul
            // cette ligne est pour pallier aux exceptions où certains matchs se jouent à une journée X avec une date éloignée des autres
            if (day < currentHighestDay) return;
            // on push
            matchParsed.push({
                date,
                day
            });
        });

        // Si tous les matchs ont été joués
        // on retourne la dernière journée
        if (matchs.length > 0 && matchParsed.length === 0) {
            return (isPlayOff) ? getMaxDayChampionnatPO() : getMaxDayChampionnatPD();
        }

        const neareastMatch = matchParsed.sort((a, b) => {
            const dateDifferenceA = Math.abs(a.date - today);
            const dateDifferenceB = Math.abs(b.date - today);
        
            // Si les dates sont égales, comparez par jour
            if (dateDifferenceA === dateDifferenceB) {
                return a.day - b.day;
            }
        
            return dateDifferenceA - dateDifferenceB;
        })[0];
        
        // on calcule la date la plus proche
        // const neareastMatch = matchParsed.reduce((a, b) => Math.abs(a.date - today) < Math.abs(b.date - today) ? a : b) || 1;
        // on change à la date la plus proche
        if(neareastMatch === undefined) return null;
        if(isPlayOff)
        {
            return handleChangeDayPO(neareastMatch.day, matchs);
        }
        return handleChangeDayPD(neareastMatch.day, matchs);
    }

    const getCurrentHighestDay = (matchs) => {
        const today = new Date();
        let currentHighestDay = 1;

        matchs.forEach((match) => {
            // on récupère la date du match
            let date = match.date;
            date = new Date(date.split('/')[2] + '-' + date.split('/')[1] + '-' + date.split('/')[0]);
            // on récupère la journée
            const day = parseInt(match.day_id);

            // on veut connaître la journée atteinte à la date d'aujourd'hui
            // si la date du match n'est toujours pas arrivé
            // alors on passe au suivant;
            if (date > today) return;

            if (day > currentHighestDay) {
                currentHighestDay = day;
            }
        });

        return currentHighestDay;
    }

    const getPlayOff = async () => { 
        setCurrentDayPO((championnat === "proam") ? 23 : 16);
        getPlayoffsMatchs((championnat === "proam") ? 23 : 16);
    }

    const getPlayDown = async () => {
        setCurrentDayPD(16);
        getPlaydownMatchs(16);
    }

    const parseMatchPO = (data, minday = currentDayPO, maxday = minday + 1) => {
        let arrayDate = [];
        const tmpDate = [];
        // on insère les dates
        data.forEach((item) => {
            let tour = item['day_id'];
            if (tour >=  minday && tour <= maxday) {
                let date = item['date'];
                // date = date.split('du')[1].trim();
                date = new Date(date.split('/')[2] + '-' + date.split('/')[1] + '-' + date.split('/')[0]);
                if (!tmpDate.includes(date.toString())) {
                    arrayDate.push({date: date, dataIndex: []});
                    tmpDate.push(date.toString());
                }
            }
        })

        // On tri le tableau par ordre croissant
        arrayDate.sort((a, b) => a.date - b.date);

        // on insère les matchs par date
        arrayDate.forEach(function(obj) {
            data.forEach((item, index) => {
                let tour = item['day_id'];
                //tour = parseInt(tour.split('°')[1].split(' ')[0]);
                if (tour >=  minday && tour <= maxday) {
                    let dateMatch = item['date'];
                    dateMatch = new Date(dateMatch.split('/')[2] + '-' + dateMatch.split('/')[1] + '-' + dateMatch.split('/')[0]);
                    if (obj.date.getTime() === dateMatch.getTime()) {
                        obj.dataIndex.push(index);
                    }
                }
            })
        })
        setParsedMatchPO(arrayDate);
    }

    const parseMatchPD = (data, minday = currentDayPD, maxday = minday + 1) => {
        let arrayDate = [];
        const tmpDate = [];
        // on insère les dates
        data.forEach((item) => {
            let tour = item['day_id'];
            if (tour >=  minday && tour <= maxday) {
                let date = item['date'];
                // date = date.split('du')[1].trim();
                date = new Date(date.split('/')[2] + '-' + date.split('/')[1] + '-' + date.split('/')[0]);
                if (!tmpDate.includes(date.toString())) {
                    arrayDate.push({date: date, dataIndex: []});
                    tmpDate.push(date.toString());
                }
            }
        })

        // On tri le tableau par ordre croissant
        arrayDate.sort((a, b) => a.date - b.date);

        // on insère les matchs par date
        arrayDate.forEach(function(obj) {
            data.forEach((item, index) => {
                let tour = item['day_id'];
                //tour = parseInt(tour.split('°')[1].split(' ')[0]);
                if (tour >=  minday && tour <= maxday) {
                    let dateMatch = item['date'];
                    dateMatch = new Date(dateMatch.split('/')[2] + '-' + dateMatch.split('/')[1] + '-' + dateMatch.split('/')[0]);
                    if (obj.date.getTime() === dateMatch.getTime()) {
                        obj.dataIndex.push(index);
                    }
                }
            })
        })
        setParsedMatchPD(arrayDate);
    }

    const getMaxDayChampionnatPO = (m = matchsPO) => {
        let maxDayChampionnat = 1; 
        m.forEach((match) => {
            // on récupère la journée
            const day = match['day_id'];
            if (day > maxDayChampionnat) {
                maxDayChampionnat = day;
            }
        });
        return maxDayChampionnat -1;
    }

    const getMaxDayChampionnatPD = (m = matchsPD) => {
        let maxDayChampionnat = 1; 
        m.forEach((match) => {
            // on récupère la journée
            const day = match['day_id'];
            if (day > maxDayChampionnat) {
                maxDayChampionnat = day;
            }
        });
        return maxDayChampionnat -1;
    }

    const handleChangeDayPO = (day , m = matchsPO) => {
        let maxDayChampionnat = getMaxDayChampionnatPO(m);
        if(championnat === "proam") {
            maxDayChampionnat = 25; /* FIX TODO */
        }
        if (day > maxDayChampionnat) {
            day = maxDayChampionnat;
        }

        if(championnat === "proam")
        {
            if (day < 23) {
                day = 23
            }
        }
        else
        {
            if (day < 16) {
                day = 16
            }
        }

        setCurrentDayPO(day);
        parseMatchPO(m, day);
        return true;
    }

    const handleChangeDayPD = (day , m = matchsPD) => {
        let maxDayChampionnat = getMaxDayChampionnatPD(m);
        if (day > maxDayChampionnat) {
            day = maxDayChampionnat;
        }

        if (day < 16) {
            day = 16
        }

        setCurrentDayPD(day);
        parseMatchPD(m, day);
        return true;
    }

    const infoMatchPO = (index, value) => {
        return matchsPO[index][value];
    }

    const infoMatchPD = (index, value) => {
        return matchsPD[index][value];
    }

    const getLevel = (index) => {
        if(championnat === "proam")
        {
            switch(index)
            {
                case 23 : case 24: return t('phase.semi');
                case 25 : case 26: return t('phase.final');
                default : return "N/A";
            }
        }
        else
        {
            switch(index)
            {
                case 16 : case 17: return t('phase.quarter');
                case 18 : case 19: return t('phase.semi');
                case 20 : case 21: return t('phase.final');
                default : return "N/A";
            }
        }
    }

    return ( 
        <div className={"box_playoff " + championnat}>
            <div className={"box_title " + championnat}>
                 <span>{getLongNameChamp(championnat)}</span>
            </div>
            <div className="box_onglet">
                <span className={currentOnglet === 1 ? "active" : ""} onClick={()=>setCurrentOnglet(1)}>{t('playoffs.playoff')}</span>
                {
                    (championnat !== "proam") &&
                    <span className={currentOnglet === 2 ? "active" : ""} onClick={()=>setCurrentOnglet(2)}>{t('playoffs.playdown')}</span>
                }
            </div>
            <div className="box_content" style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
                {
                    currentOnglet === 1 &&
                    <div className="box_off">
                        <div className="box_calendar_day">
                            <IoIosArrowUp className="box_day_arrow" size={22} style={{transform: 'rotate(-90deg)'}} onClick={()=>handleChangeDayPO(currentDayPO - 2)}/>
                            <span className={championnat}>{getLevel(currentDayPO)}</span>
                            <IoIosArrowUp className="box_day_arrow" size={22} style={{transform: 'rotate(90deg)'}} onClick={()=>handleChangeDayPO(currentDayPO + 2)}/>
                        </div>
                        <div className="box_calendar_matchs" style={{width: '100%'}}>
                            {
                                (parsedMatchPO.length === 0) &&
                                    <div className='text_content'>
                                        <span className='text_center'>{t('playoffs.noData')}</span>
                                    </div>
                            }
                            {
                                parsedMatchPO.map((item,index) => {
                                    return (
                                        <div key={index} className="box_calendar_date">
                                            <span className={"box_calendar_date_span " + championnat}>{item.date.toLocaleDateString(locale, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</span>
                                            {
                                                item.dataIndex.map((data) => {
                                                    return (
                                                        <div key={data} style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 15, textAlign: 'center', width: '100%', marginBottom: 5}}>
                                                            <span className="box_calendar_equipe">{infoMatchPO(data, 'domicile')}</span> 
                                                            {
                                                                (infoMatchPO(data, "home_points") !== null && infoMatchPO(data, "away_points") !== null &&
                                                                <span className="box_calendar_time" style={{letterSpacing: 2}}>{infoMatchPO(data, 'home_points') + " - " + infoMatchPO(data, 'away_points')}</span>)
                                                                ||
                                                                <span className="box_calendar_time">{t('common.vs').toUpperCase()}</span>
                                                            }
                                                            
                                                            <span key={data} className="box_calendar_equipe">{infoMatchPO(data, 'exterieur')}</span> 
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    )
                                })
                            }  
                        
                        </div>
                    </div>
                }
                {
                    currentOnglet === 2 &&
                    <div className="box_down">
                        <div className="box_calendar_day">
                            <IoIosArrowUp className="box_day_arrow" size={22} style={{transform: 'rotate(-90deg)'}} onClick={()=>handleChangeDayPD(currentDayPD - 2)}/>
                            <span className={championnat}>{getLevel(currentDayPD)}</span>
                            <IoIosArrowUp className="box_day_arrow" size={22} style={{transform: 'rotate(90deg)'}} onClick={()=>handleChangeDayPD(currentDayPD + 2)}/>
                        </div>
                        <div className="box_calendar_matchs" style={{width: '100%'}}>
                            {
                                (parsedMatchPO.length === 0) &&
                                    <div className='text_content'>
                                        <span className='text_center'>{t('playoffs.noData')}</span>
                                    </div>
                            }
                            {
                                parsedMatchPD.map((item,index) => {
                                    return (
                                        <div key={index} className="box_calendar_date">
                                            <span className={"box_calendar_date_span " + championnat}>{item.date.toLocaleDateString(locale, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</span>
                                            {
                                                item.dataIndex.map((data) => {
                                                    return (
                                                        <div key={data} style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 15, textAlign: 'center', width: '100%', marginBottom: 5}}>
                                                            <span className="box_calendar_equipe">{infoMatchPD(data, 'domicile')}</span> 
                                                            {
                                                                (infoMatchPD(data, "home_points") !== null && infoMatchPD(data, "away_points") !== null &&
                                                                <span className="box_calendar_time" style={{letterSpacing: 2}}>{infoMatchPD(data, 'home_points') + " - " + infoMatchPD(data, 'away_points')}</span>)
                                                                ||
                                                                <span className="box_calendar_time">{t('common.vs').toUpperCase()}</span>
                                                            }
                                                            
                                                            <span key={data} className="box_calendar_equipe">{infoMatchPD(data, 'exterieur')}</span> 
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                }
            </div>
            <div className='menu_bottom'>
                <span className={"box_span_details " + championnat} onClick={()=>navigate('/'+championnat+'/classement')}>{t('box.fullStandings')}</span>
            </div>
        </div>
    );
}

export default BoxPlayOff;